// extracted by mini-css-extract-plugin
export default {"textContainer":"Text_textContainer__O+cvY","title":"Text_title__6VD7p","body":"Text_body__-+Mx6"};